import { createContext } from 'react';

import { ReactRouterDOMContext } from '../types';

const defaultValue: ReactRouterDOMContext = {
    params: {},
    router: {
        push: () => {},
        replace: () => {},
        go: () => {},
        goBack: () => {},
        goForward: () => {},
        setRouteLeaveHook: () => () => {},
        createPath: () => '',
        createHref: () => '',
        isActive: () => false,
    },
    location: {},
};

const ReactRouterContext = createContext<ReactRouterDOMContext>(defaultValue);
ReactRouterContext.displayName = 'ReactRouterContext';

export default ReactRouterContext;
